webpackJsonp([64],{

/***/ "6p0q":
/***/ (function(module, exports, __webpack_require__) {

var SectionDifferentDevices = (function () {
    function SectionDifferentDevices() {
    }
    return SectionDifferentDevices;
}());
angular.module('animatronApp.sectionDifferentDevices', []).component('sectionDifferentDevices', {
    bindings: {
        ltTitle: '<',
        buttons: '<?',
        description: '<',
        videos: '<'
    },
    controller: SectionDifferentDevices,
    templateUrl: __webpack_require__("w7UM")
});


/***/ }),

/***/ "w7UM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-different-devices_40de2009312bd4ea95c5310067f5233f.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/64-28dc41a6a889e793a2e2.min.js